import React from "react"

import Layout from '../components/layout/layout'
import Sidebar from '../components/sidebar/sidebar'
import {findSectionForPath} from "../utils/findSectionForPath";
import {sectionListDocsRu} from "../utils/sections";
import {createLinkDocs} from "../utils/createLink";


const Main = (props) => {

    return (
        <Layout location={props.location}>
             <Sidebar activeSection={findSectionForPath(props.location.pathname, sectionListDocsRu)}
                     sectionList={sectionListDocsRu} createLink={createLinkDocs} location={props.location}/>
        </Layout>
    )
};

export default Main
